import React from "react";
import { media } from "./theme";
import { useMedia } from "react-use";

const CommingSoonPage = () => {
  const isDesktop = useMedia(media.lg);
  return (
    <img
      className={"w-100"}
      src={
        isDesktop
          ? "/comming_soon_allodedicace_desktop.png"
          : "/comming_soon_allodedicace_mobile.png"
      }
      alt="comming soon image"
    />
  );
};

export default CommingSoonPage;
